import React from "react"
import PropTypes from "prop-types"

import { Elements } from "@stripe/react-stripe-js"

const options = { appearance: { theme: "flat" } }

StripeWrapper.propTypes = {
  children: PropTypes.node.isRequired
}
export default function StripeWrapper({ children }) {
  const stripePromise = import("@stripe/stripe-js").then(({ loadStripe }) => loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY))

  return (
    <Elements stripe={stripePromise} options={options}>
      {children}
    </Elements>
  )
}
